<template>
  <detail-row-wrapper :save-function="submit" :cancel-function="cancel">

    <div class="contents-wrapper">

      <div class="main-contents">

        <detail-row-component title="이름">

          <layout-input v-model="editable.name"
                        placeHolder="이름을 입력해주세요."
                        :regex="regex(1, 10000).ko_en_num"/>

        </detail-row-component>

        <detail-row-component title="차량 타입">

          <layout-radio-button v-model="editable.vehicleType"
                               :name="`type${rowIndex}`"
                               :select-list="['wp', 'e24']"
                               :view-list="['와인포인트', '이마트24']"/>

        </detail-row-component>

      </div>

    </div>
  </detail-row-wrapper>
</template>

<script>
import { validate, multipleValidate, regex } from '@/utils/utils';

import LayoutInput from '@/spa/components/LayoutInput';
import LayoutRadioButton from '@/spa/components/LayoutRadioButton';

import DetailRowWrapper from '@/spa/components/detail-row/DetailRowWrapper';
import DetailRowComponent from '@/spa/components/detail-row/DetailRowComponent';

export default {
  name: 'VehicleEditor',
  components: {
    LayoutInput,
    LayoutRadioButton,

    DetailRowWrapper,
    DetailRowComponent,
  },
  props: {
    rowData: {
      type: Object,
      required: true,
    },
    rowIndex: {
      type: Number,
    },
  },
  methods: {
    regex(min, max) {
      return regex(min, max);
    },

    async submit() {
      this.editable.id = parseInt(this.rowData.id, 10);

      const validateResult = multipleValidate([
        validate({ message: '이름', target: this.editable.name }),
      ]);

      if (validateResult.flag) {
        this.$toast(validateResult.message);
        return;
      }

      const result = await this.$store.dispatch('updateWarehouse', this.editable);

      if (result.response) {
        this.$table.updateField();
      }

      this.$toast(result.message);
    },

    cancel() {
      this.$table.updateField();
    },
  },
  data() {
    return {
      editable: {
        name: this.rowData.name,
        vehicleType: this.rowData.vehicle_type || 'wp',
      },
    };
  },
};
</script>

<style lang="scss" scoped>
.contents-wrapper {
  position: relative;
  min-height: auto;

  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;

  flex-direction: row;

  .main-contents {
    position: relative;
    width: 100%;

    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    align-content: flex-start;

    flex-direction: column;
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/board/warehouse/detail-row/VehicleEditor.vue